import { render, staticRenderFns } from "./TableSkp.vue?vue&type=template&id=08c6ce32&"
import script from "./TableSkp.vue?vue&type=script&lang=js&"
export * from "./TableSkp.vue?vue&type=script&lang=js&"
import style0 from "./TableSkp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports